import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LoginRedirectRoutingModule } from './login-redirect-routing.module';
import { LoginRedirectComponent } from './login-redirect.component';

@NgModule({
	declarations: [
		LoginRedirectComponent
	],
	imports: [
		CommonModule,
		LoginRedirectRoutingModule
	]
})
export class LoginRedirectModule {}
